module.exports = __webpack_public_path__ + "static/img/gnld_4@2x.8a44f167.png";